import VTable from "@/vuetify_custom/v-table/v3";
import { formattingNumber } from "@/libs/util.js";
import { VIcon } from "vuetify/lib";
import styles from "@/views/blogger/resourcelibrary/style.module.less";
export default {
  props: {
    list: {
      type: Array,
    },
    loading: {
      type: Boolean,
    },
  },
  computed: {
    table_fields() {
      return [
        {
          text: "投放编号",
          align: "center",
          value: "uid",
          width: 120,

          render: (v) => {
            return <div>{v}</div>;
          },
        },
        {
          text: "发布时间",
          align: "center",
          value: "publish_at",
          width: 120,
        },
        {
          text: "SKU",
          align: "center",
          value: "sku",
          width: 140,
          render: (_, t) => (
            <div>
              <div>{(t.sku && t.sku.sku_name) || "-"}</div>
            </div>
          ),
        },

        {
          text: "投放金额",
          type: "money_field",
          align: "left",
          value: "leiji",
          width: 170,
          render: (_, target) => {
            const res = math.eval(
              `${target.vas_amount || 0}+${target.payable_price || 0}+${
                target.addition_amount || 0
              }-${target.rebate_amount || 0}`
            );
            return (
              <div>
                {/* <div class={styles['dis-flex']}><span>预计投放金额：</span><span class={styles['flex-1']} style="text-align:right">{formattingNumber(target.total_price, 2)}</span></div> */}
                {/* <div class={styles['dis-flex']}><span>实际消耗：</span><span class={styles['flex-1']} style="text-align:right">{formattingNumber(target.payable_price, 2)}</span></div> */}
                <div class={styles["dis-flex"]}>
                  <span>累计消耗：</span>
                  <span class={styles["flex-1"]} style="text-align:right">
                    {formattingNumber(res.toNumber(), 2)}
                  </span>
                </div>
                {/* <div class={styles['dis-flex']}><span>累计金额：</span><span class={styles['flex-1']} style="text-align:right">{formattingNumber(res.toNumber(), 2)}</span></div> */}
              </div>
            );
          },
        },
        {
          text: "效果数据", // 点赞评论收藏播放
          align: "left",
          value: "first_week_effect",
          width: 170,
          render: (_) => {
            if (_) {
              return (
                <div>
                  <VIcon color="orange darken-2" small>
                    mdi-thumb-up
                  </VIcon>
                  :{_.like_num}
                  <VIcon color="blue darken-2" small>
                    mdi-comment
                  </VIcon>
                  :{_.comment_num}
                  <VIcon color="#FFD600" small>
                    mdi-star
                  </VIcon>
                  :{_.favorite_num}
                  <VIcon color="deep-orange darken-1" small>
                    mdi-play-circle
                  </VIcon>
                  :{_.view_num}
                </div>
              );
            } else {
              return <div></div>;
            }
          },
        },
      ];
    },
  },
  render() {
    return (
      <VTable
        loading={this.loading}
        headers={this.table_fields}
        class={styles["table"]}
        desserts={this.list ? this.list.slice(0, 10) : []}
      />
    );
  },
};
